import {useLoaderData, useNavigate, useRouteLoaderData} from "react-router";
import {useTranslation} from "react-i18next";
import {Badge, Breadcrumb, Col, Container, Row} from "react-bootstrap";
import {InviteForm} from "./forms/InviteForm";

export const Invite = (props) => {

    const {currentUser} = useRouteLoaderData("root");
    const user = useLoaderData();
    const {t} = useTranslation();
    const navigate = useNavigate();

    const handleHome = () => {
        navigate("/")
    }

    return (
        <Container fluid={true}>
            <Row className={"justify-content-end"}>
                <Col className={"d-flex justify-content-start"}>
                    <Breadcrumb className={"mt-3"}>
                        <Breadcrumb.Item onClick={handleHome}>{t('breadcrumbs.home')}</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {t('breadcrumbs.invite')}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            <InviteForm/>
        </Container>
    );
}